import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = window.matchMedia("(max-width: 750px)");

function useMobileViewportCheck() {
  const [mobileViewport, setViewport] = useState(MOBILE_BREAKPOINT.matches);
  useEffect(() => {
    const handleResize = () => setViewport(MOBILE_BREAKPOINT.matches);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return mobileViewport;
}

export default useMobileViewportCheck;
